const {createObject, createString, traversePropertiesString} = require('../../shared');

module.exports.sponsorSpouse = function (appData, formData, outData){

  if (!outData.error && !createObject(appData, "sponsor", {})) {
    outData.error = "Cannot create sponsor info";
  }

  if (!outData.error && !createString(appData.sponsor, "firstName", traversePropertiesString(formData,['primary','fname']), true)) {
    outData.error = "Cannot set sponsor First Name";
  }

  if (!outData.error && !createString(appData.sponsor, "middleInitital", traversePropertiesString(formData,['primary','middleInitial']))) {
    outData.error = "Cannot set sponsor Middle Initial";
  }

  if (!outData.error && !createString(appData.sponsor, "lastName", traversePropertiesString(formData,['primary','lname']), true)) {
    outData.error = "Cannot set sponsor Last Name";
  }


  if (!outData.error && !createString(appData.sponsor, "ssn", traversePropertiesString(formData,['primary','ssn']), true)) {
    outData.error = "Cannot set sponsor SSN";
  }

  if (!outData.error && !createString(appData.sponsor, "dutyStatus", traversePropertiesString(formData,['primary','dutyStatus']), true)) {
    outData.error = "Cannot set sponsor dutyStatus";
  }

  if (!outData.error && !createString(appData.sponsor, "branch", traversePropertiesString(formData,['primary','branch']), true)) {
    outData.error = "Cannot set sponsor branch";
  }

  if (!outData.error && !createString(appData.sponsor, "rank", traversePropertiesString(formData,['primary','rank']), true)) {
    outData.error = "Cannot set sponsor rank";
  }

  if (!outData.error && !createString(appData.sponsor, "serviceUnit", traversePropertiesString(formData,['primary','serviceUnit']), false)) {
    outData.error = "Cannot set sponsor serviceUnit";
  }

  if (!outData.error && !createString(appData.sponsor, "unitPhone", traversePropertiesString(formData,['primary','workPhone']), false)) {
    outData.error = "Cannot set sponsor unitPhone";
  }

}


// WEBPACK FOOTER //
// ./src/containers/Applications/shared/appConverters/MBA/sponsorSpouse.js